<template>
  <div>
    <validation-provider
      :name="question.label"
      v-if="hasAnswer(answer) && isTextType(question) && isRequired(question)"
      rules="required"
      mode="lazy"
      v-slot="{ errors }"
    >
      <h4 class="question_text__title required" v-html="sanitizedQuestion + ' *'"></h4>
      <p class="question_text__description">{{ question.attributes.description }}</p>
      <vs-input
        class="question_text__input no-icon-border"
        type="text"
        v-model="answer.value"
        :danger="errors.length > 0"
        :danger-text="`Campo de resposta obrigatória` || ''"
        @change="$emit('input', event.target.value)"
      />
    </validation-provider>
    <validation-provider
      :name="question.label"
      v-if="hasAnswer(answer) && isTextType(question) && !isRequired(question)"
      v-slot="{ errors }"
      mode="lazy"
    >
      <h4 class="question_text__title" v-html="sanitizedQuestion"></h4>
      <p class="question_text__description">{{ question.attributes.description }}</p>
      <vs-input
        class="question_text__input no-icon-border"
        type="text"
        v-model="answer.value"
        :danger="errors.length > 0"
        :danger-text="errors[0] || ''"
        @change="$emit('change', $event.target.value)"
      />
    </validation-provider>
  </div>
</template>

<style lang="scss" scoped>
.question_text__title {
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  color: #4F4F4F;
  margin: 10px 0;

  // Estilos para listas no conteúdo HTML
  ::v-deep ul {
    list-style-type: disc;
    list-style-position: outside;
    padding-left: 20px;
    margin: 10px 0;
    
    li {
      margin-bottom: 8px;
      line-height: 1.4;
    }
  }

  ::v-deep ol {
    list-style-type: decimal;
    list-style-position: outside;
    padding-left: 20px;
    margin: 10px 0;
    
    li {
      margin-bottom: 8px;
      line-height: 1.4;
    }
  }

  ::v-deep p {
    margin: 8px 0;
    line-height: 1.4;
  }

  ::v-deep br {
    line-height: 1.4;
  }

  ::v-deep strong {
    font-weight: 600;
  }

  ::v-deep em {
    font-style: italic;
  }

  ::v-deep a {
    color: #4169E1;
    text-decoration: underline;
    
    &:hover {
      color: darken(#4169E1, 15%);
    }
  }
}

.question_text__description {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  color: #4F4F4F;
  margin-bottom: 10px;
}

.question_text__input {
  width: 100%;
  margin-bottom: 5px;
  color: #000;
}

.required {
  color: #333333;
}
</style>

<script>
import { ValidationProvider } from "vee-validate";
import { sanitizeBasicHtml } from "@/utils/htmlSanitizer";

export default {
  components: { ValidationProvider },
  name: "question-text",
  props: {
    answer: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    }
  },
  computed: {
    sanitizedQuestion() {
      return sanitizeBasicHtml(this.question.question);
    }
  },
  methods: {
    hasAnswer: answer => Object.keys(answer).length > 0,
    isTextType: question => question.type === "text",
    isRequired: question => question.required
  }
};
</script>
